import PropTypes from 'prop-types';

import { Stack } from '@mui/material';
import { ClockingsToolbar } from '../clockings';
import ClockingsToolbarInit from '../clockings/ClockingsToolbarInit';
import Page from '../../organisms/Page';

import useLayout from '../../../hooks/useLayout';

const LayoutInit = (props) => {
  const { children, pagename, handleClickBack } = props;
  const styleMain = useLayout();

  return (
    <Stack className="clockings-root" sx={styleRoot}>
      <ClockingsToolbar color="comete">
        <ClockingsToolbarInit pagename={pagename} handleClickBack={handleClickBack} />
      </ClockingsToolbar>

      <Page className="clockings-initialization-page" title={pagename}>
        <Stack className="clockings-main" sx={styleMain}>
          {[children]}
        </Stack>
      </Page>
    </Stack>
  );
};

const styleRoot = {
  minHeight: '100%', // 100vh break layout on iOS
  overflow: 'hidden'
};

LayoutInit.propTypes = {
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  pagename: PropTypes.string.isRequired,
  handleClickBack: PropTypes.func
};

export default LayoutInit;
